import {createContext} from 'react';
import {ProspectScoreCustomizeItem} from 'api';

export const CustomizeItemContext =
  createContext<ProspectScoreCustomizeItem>(null);
